<template>
  <div>
    <div class="onBoardRegistration padd" id="login">
       
      <div v-if="showToastSuccess">
        <div
          style="
            margin-bottom: 25px;
            padding: 20px;
            background-color: #0297A7;
            border-radius: 20px;
            color: white;
            display: -webkit-flex;
            display: flex;
            align-items: center;
          "
        >
          <span class="warpit_icon_check-round" style="font-size: 32px; margin-right: 15px"></span>
          {{ showToastSuccessMessage }}
        </div>
      </div>

      <div v-if="showToastError">
        <div
          style="
            margin-bottom: 25px;
            padding: 20px;
            background-color: #ef5451;
            border-radius: 20px;
            color: white;
            display: -webkit-flex;
            display: flex;
            align-items: center;
          "
        >
          <span class="warpit_icon_alert" style="font-size: 32px; margin-right: 15px"></span>
          {{ showToastMessage }}
        </div>
      </div>

      <form action="#" class="custom-form"
        v-on:submit.prevent="onSubmit()"
         >
        

        <div class="form-group" v-bind:class="{ 'not-empty': !isEmailEmpty }">
          <input
            type="text"
            class="form-control"
            name="email_login"
            id="email_login"
            v-model="form.email"
            v-on:keypress="formUtilsValidateInputEmptySpaces($event)"
            required
            @blur="formUtilsCheckEmail()"
          />
          <label for="email_login" class="animated-label">{{ $t("login.email") }}</label>
          <span class="line"></span>
        </div>

        <span class="errorSexTxt" v-if="errors.email" for="email_login">{{ $t("error.invalid_email") }}</span>
        

        <div class="form-group" v-bind:class="{ 'not-empty': !isPasswordEmpty}">
          <input
            v-bind:type="passwordType"
            class="form-control"
            name="pass_login"
            id="pass_login"
            v-model="form.password"
            required
            @blur="formUtilsCheckPassword()"
            @paste="formUtilsOnPaste($event)"
          />
          <label for="pass_login" class="animated-label">{{ $t("global.password") }}</label>
          <span
            class="icon passVisible"
            v-bind:class="{
              warpit_icon_eye: isPasswordEyeSlashClass,
              'warpit_icon_eye-slash': !isPasswordEyeSlashClass,
            }"
            v-on:click.prevent="formUtilsShowPassword()"
          ></span>
          <span class="line"></span>
        </div>
        
        
        <div class="form-group stay-login">
         <label class="switch">
            <input id="stayLoggedIn" type="checkbox" v-model="form.stayLoggedIn" />
            <span class="slider round"></span>
          </label>
          <label for="stayLoggedIn">
            {{ $t("login.keep_login") }}
          </label>
        </div>
        
        
        <div class="next flex">
          <router-link :to="{ name: 'resetpasswordrequest' }">
            <a class="txt">{{ $t("login.forgotpassword") }}</a>
          </router-link>

          <a
            class="join smallFont hoverEffect"
            ref="loginButton"
            v-on:mouseover="formUtilsMouseHoverEffect($event, 'loginButton')"
            v-on:mouseout="formUtilsMouseHoverEffect($event, 'loginButton')"
            v-on:click.prevent="onSubmit()"
            href="javascript:void(0);"
          >
            <label>{{ $t("login.submit") }}</label>
            <span
              class="effect"
              ref="effectLoginButton"
              v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
            ></span>
            <img src="@/assets/images/nextArrowAnimation.svg" />
          </a>
        </div>


      </form>
    </div>
  </div>
</template>
<script>

import { 
  formUtilsCheckEmail, 
  formUtilsOnPaste, 
  formUtilsValidateInputEmptySpaces,
  formUtilsCheckAnimation, 
  formUtilsCheckPassword, 
  formUtilsMouseHoverEffect, 
  formUtilsShowPassword 
} from '@/utils/form_utils.js';

export default {
  data() {
    return {
      showToastError: false,
      showToastSuccess: false,
      showToastMessage: "",
      showToastSuccessMessage:"",
      isPasswordEyeSlashClass: true,
      passwordType: "password",
      isPasswordEmpty: true,
      isEmailEmpty: true,
      email: "",
      forgotEmail: "",
      
      form: {
        email: "",
        password: "",
        stayLoggedIn: true,
        recaptchaToken: "",
      },
      errors: {
        email: false,
        password: false,
      },
      topX: 1,
      leftX: 1
    };
  },

  mounted() {
    console.log('LOGIN mounted START');
    this.$initRecaptcha();

    if(this.$route.query.verified){
      this.showToastSuccess = true;
      this.showToastSuccessMessage = this.$t('login.success_verification');
    }
    if(this.$route.params.email){
      this.email = this.$route.params.email;
    }
    this.$store.dispatch("app/loader", false);
    this.formUtilsCheckAnimation();
    console.log('LOGIN mounted END');
  },

  methods: {
    formUtilsCheckEmail,
    formUtilsOnPaste,
    formUtilsValidateInputEmptySpaces,
    formUtilsCheckPassword,
    formUtilsMouseHoverEffect,
    formUtilsShowPassword,
    formUtilsCheckAnimation,

    onSubmit() {
      /* CHECK FIELDS BEFORE SUBMIT */
      this.formUtilsCheckEmail();
      if (this.errors.email === true) {
        return;
      }

      /* CHECK CAPTCHA */
      this.$checkRecaptcha().then((token) => {
        this.sendForm(token);
      }).catch((error) => {
        console.error("Error reCAPTCHA:", error);
      });
    },

    sendForm(recaptchaToken) {
      this.form.recaptchaToken = recaptchaToken;

      this.$store
        .dispatch("user/login", this.form)
        .then(
          () => {
            if(this.$route.params.action !== undefined){
              this.$router.push({
                name: "myprofile",
                params: { email: this.email, password: this.password, action: 'delete_account' },
              });
            } else {
              this.$router.push({
                name: "dashboard",
                params: { email: this.email, password: this.password },
              });
            }
            return;
          },
          () => {
            this.showToastMessage = this.$t("error.invalid_login");
            this.showToastError = true;
          }
        );
    }
  },
};
</script>
<style scoped>
textarea {
  border: none;
  background-color: transparent;
  resize: none;
  outline: none;
}
input:focus {
  outline: none !important;
}
a {
  color: #337ab7;
  text-decoration: none;
}
.stay-login{
  justify-content: flex-start !important;
}
.stay-login label{
  margin-right:10px;
}

</style>
